import Alpine from "alpinejs";
import intersect from "@alpinejs/intersect";
import collapse from "@alpinejs/collapse";
import Cookies from 'js-cookie';
import EmblaCarousel from "embla-carousel";
import Autoplay from "embla-carousel-autoplay";
import { Fancybox } from "@fancyapps/ui";
import "./components/nav";
import "./components/fitvids";
import { addThumbBtnsClickHandlers, addToggleThumbBtnsActive, addDotBtnsAndClickHandlers } from "./components/embla-extensions";

window.Alpine = Alpine;
window.Cookies = Cookies;
Alpine.plugin(intersect);
Alpine.plugin(collapse);
Alpine.start();

const togglePaletteClass = function (cssPrefix, element, newClass) {
	Array.from(element.classList).forEach((className) => {
		if (className.startsWith(cssPrefix)) {
			element.classList.remove(className);
		}
	});
	element.classList.add(newClass);
};

document.addEventListener("DOMContentLoaded", function (event) {
	/**
	 * Fancybox stuff
	 */
	Fancybox.bind("[data-fancybox]", {});

	/**
	 * Scale videos
	 */
	fitVids({
		customSelector: ".wp-block-embed",
	});

	/**
	 * Home page slider
	 * Adds dots outside main viewport
	 * Changes <body> with slider theme for nav colours
	 */
	if (document.querySelector(".block-slider")) {
		document.querySelectorAll(".block-slider").forEach((el) => {
			const rootNode = el;
			const embla = EmblaCarousel(
				rootNode.querySelector(".embla__viewport"),
				{
					loop: true,
				},
				[Autoplay({ delay: 5000 })]
			);
			const dotsNode = rootNode.querySelector(".embla__dots");
			const removeDotBtnsAndClickHandlers = addDotBtnsAndClickHandlers(embla, dotsNode);
			const changeThemeColor = (embla, eventName) => {
				const index = embla.selectedScrollSnap();
				const slide = rootNode.querySelectorAll(".embla__slide")[index];
				togglePaletteClass("slider__", document.querySelector("body"), slide.dataset.palette);
				rootNode.querySelectorAll(".embla__slide").forEach((el) => {
					el.classList.remove("is-selected");
				});
				slide.classList.add("is-selected");
			};
			embla.on("init", () => {
				embla.plugins().autoplay.stop();
				rootNode.querySelector(".embla").classList.add("is-enabled");
				changeThemeColor(embla);
				setTimeout(() => {
					embla.plugins().autoplay.play();
				}, 1000);
			});
			embla.on("select", changeThemeColor);
			embla.on("destroy", removeDotBtnsAndClickHandlers);
		});
	}

	/**
	 * Testimonials slider
	 * Next/prev are outside main viewport
	 * Multiple on page allowed
	 */
	if (document.querySelector(".block-testimonials")) {
		document.querySelectorAll(".block-testimonials").forEach((el) => {
			const rootNode = el;
			const embla = EmblaCarousel(rootNode.querySelector(".embla__viewport"), {
				loop: false,
			});
			rootNode.querySelector(".embla__prev").addEventListener("click", embla.scrollPrev, false);
			rootNode.querySelector(".embla__next").addEventListener("click", embla.scrollNext, false);
		});
	}

	/**
	 * Carousel slider
	 * Has second slider for thumbnails
	 */
	if (document.querySelector(".block-carousel")) {
		document.querySelectorAll(".block-carousel").forEach((el) => {
			const rootNode = el;
			const emblaApiMain = EmblaCarousel(rootNode.querySelector(".embla__viewport"), {});
			const emblaApiThumb = EmblaCarousel(rootNode.querySelector(".embla-thumbs__viewport"), {
				containScroll: "keepSnaps",
				dragFree: true,
			});
			const removeThumbBtnsClickHandlers = addThumbBtnsClickHandlers(emblaApiMain, emblaApiThumb);
			const removeToggleThumbBtnsActive = addToggleThumbBtnsActive(emblaApiMain, emblaApiThumb);
			rootNode.querySelector(".embla__prev").addEventListener("click", emblaApiMain.scrollPrev, false);
			rootNode.querySelector(".embla__next").addEventListener("click", emblaApiMain.scrollNext, false);
			emblaApiMain.on("destroy", removeThumbBtnsClickHandlers).on("destroy", removeToggleThumbBtnsActive);
			emblaApiThumb.on("destroy", removeThumbBtnsClickHandlers).on("destroy", removeToggleThumbBtnsActive);
		});
	}

	/**
	 * Carousel slider
	 * Has second slider for thumbnails
	 */
	if (document.querySelector(".block-gallery")) {
		document.querySelectorAll(".block-gallery").forEach((el) => {
			const rootNode = el;
			const embla = EmblaCarousel(
				rootNode.querySelector(".embla__viewport"),
				{
					loop: true,
				},
				[Autoplay({ delay: 5000 })]
			);
			const dotsNode = rootNode.querySelector(".embla__dots");
			const removeDotBtnsAndClickHandlers = addDotBtnsAndClickHandlers(embla, dotsNode);
		});
	}
});
